module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAf0lEQVR42u3aQQ3AMAwDwEDocwBGs1RHxX1Ww+CLZAL3ipVMkmnOAAAAAAAAAAAAAABQDvCtJ00BAAAAAAAA/ntA2wAAAAAAgNuK3p2mAAAAAAAAAAAAAAAAAAAAdRgAAAAA2gHcBgEAAAAAQPeDhE9RAAAAAAAAAAAAAAB6cgCp8Pi/UW+W5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Thailand.png
// module id = tJIu
// module chunks = 0 62 63